export const Modal = {
  baseStyle: {
    _backdrop: {
      bg: 'gray.900',
      opacity: 0.7,
    },
  },
  sizes: {
    full: {
      px: 4,
      contentSize: {
        width: '100%',
        maxWidth: 600,
      },
    },
  },
}

export const ModalContent = {
  baseStyle: {
    borderRadius: '2xl',
  },
  variants: {
    noShadow: {
      boxShadow: 'none',
      _light: {
        boxShadow: 'none',
      },
    },
  },
}

export const ModalCloseButton = {
  baseStyle: {
    top: '10px',
    right: '10px',
    _light: {
      _icon: {
        color: 'gray.900',
      },
    },
  },
}

export const ModalBody = {
  baseStyle: {
    py: 0,
  },
}

export const ModalFooter = {
  baseStyle: {
    borderTopWidth: 0,
    py: 4,
  },
}

export const ModalHeader = {
  baseStyle: {
    borderBottomWidth: 0,
    pt: 6,
    pb: 4,
  },
}
